import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    apiEndpoint: 'https://api.trustpilot.com/v1',
    apiKey: '7iHqPYmTa9QpgpilWg6IUAqRvVVoCEwc',
    businessUnitId: '5cb8500b23137100015bdc5b',
    reviews: [],
    businessData: {},
  },
  getters: {
    getReviews: (state) => state.reviews,
    getBusinessData: (state) => state.businessData,
  },
  mutations: {
    setReviews: (state, payload) => {
      state.reviews = payload;
    },
    setBusinessData: (state, payload) => {
      state.businessData = payload;
    },
  },
  actions: {

    // Get Product reviews - this includes Trust Pilot and imported reviews - params@ product/villa id
    async getProductReview({ state }, productID) {
      const productReviewsURL = `${state.apiEndpoint}/product-reviews/business-units/${state.businessUnitId}/reviews?sku=${productID}&apikey=${state.apiKey}`;
      const importedProductReviewsURL = `${state.apiEndpoint}/product-reviews/business-units/${state.businessUnitId}/imported-reviews?sku=${productID}&apikey=${state.apiKey}`;

      try {
        const productReviews = await axios.get(productReviewsURL);
        const importedProductReviews = await axios.get(importedProductReviewsURL);
        const allProductReviews = [...productReviews.data.productReviews, ...importedProductReviews.data.productReviews];
        return allProductReviews;
      } catch (error) {
        // console.log('getProductReview error = ', error);
        return false;
      }
    },

    // Get product reviews average star ratings
    async getProductReviewsSummary({ state, commit }, productID) {
      const productReviewsSummaryURL = `${state.apiEndpoint}/product-reviews/business-units/${state.businessUnitId}/?sku=${productID}&apikey=${state.apiKey}`;
      const importedProductReviewsSummaryURL = `${state.apiEndpoint}/product-reviews/business-units/${state.businessUnitId}/imported-reviews-summaries?sku=${productID}&apikey=${state.apiKey}`;
      try {
        const productReviewsSummary = await axios.get(productReviewsSummaryURL);
        const importedProductReviewsSummary = await axios.get(importedProductReviewsSummaryURL);

        const psr = productReviewsSummary.data.numberOfReviews;
        const ipsr = importedProductReviewsSummary.data.numberOfReviews;

        const add = (...args) => args.reduce((acc, val) => acc + val, 0);

        const fiveStars = (psr.fiveStars * 5) + (ipsr.fiveStars * 5);
        const fourStars = (psr.fourStars * 4) + (ipsr.fourStars * 4);
        const threeStars = (psr.threeStars * 3) + (ipsr.threeStars * 3);
        const twoStars = (psr.twoStars * 2) + (ipsr.twoStars * 2);
        const oneStar = (psr.oneStar) + (ipsr.oneStar);
        const total = add(oneStar, twoStars, threeStars, fourStars, fiveStars);
        const numberOfReviews = psr.total + ipsr.total;
        const average = numberOfReviews > 0 ? (total / numberOfReviews).toFixed(1) : 0;
        const starsAverage = String(average).split('.')[1] == '0' ? Number(average).toFixed(0) : Number(average);

        return { starsAverage, numberOfReviews };
      } catch (error) {
        // console.log('getProductReviewsSummary error = ', error);
        return false;
      }
    },

    // Fetch all company reviews
    async fetchAllCompanyReviews({ state, commit }) {
      const reviewsURL = `${state.apiEndpoint}/business-units/${state.businessUnitId}/reviews?apikey=${state.apiKey}&perPage=100`;
      if (state.reviews.length > 0) {
        return;
      }

      try {
        const res = await axios.get(reviewsURL);
        const companyReviews = res.data.reviews.map((rev) => {
          rev.showReply = false;
          return rev;
        });
        commit('setReviews', companyReviews);
      } catch (error) {
        console.log('GET ALL REVIEWS error = ', error);
      }
    },

    // Fetch company Business data - this includes summaries for reviews and scores
    async fetchBusinessData({ state, commit }) {
      const url = `${state.apiEndpoint}/business-units/${state.businessUnitId}?apikey=${state.apiKey}`;

      if (state.businessData.id) {
        return;
      }

      try {
        const res = await axios.get(url);
        const data = res.data;

        // Get the string representation of the stars based on the stars score returned
        const ratingURL = `${state.apiEndpoint}/resources/strings/stars/${data.score.stars}?apikey=${state.apiKey}`;
        const rating = await axios.get(ratingURL);
        data.rating = rating.data.string;

        commit('setBusinessData', data);
      } catch (error) {
        console.log('GET BUSINESS DATA error = ', error);
      }
    },

  },
};
